import React from "react";
import { useDrop } from "react-dnd";
import { MayaDestination } from "../components/Maya";
import { FONT } from "../defaults";
import basket from "../images/basket.png";
import corn from "../images/corn.png";
import "./Box.css";


const mayaImages = [corn, basket];

/* 
This component implements a box into which Maya images can be dropped.
Parts of it were created with the help of LLMs.
*/
function MayaBoxDestination({ id, droppedItems, onDropItem, itemSize }) {
  const [, drop] = useDrop({
    accept: "maya-origin",
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        onDropItem(item.id, id); // item.id is 2d-array. item[0] is index of item that was dropped, that index corresponds to a char (e.g. in Roman 2 = 'X'). id is the index of the box it was dropped in.
      }
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
      canDrop: !!monitor.canDrop(),
    }),
  });

  const containerStyle = {
    display: "flex",
    flexDirection: "row",
    width: 4*itemSize+"dvh",
    justifyContent: "center",
  };
  
  const containerArrayStyle = {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    rowGap: "3dvh",
    justifyContent: "center",
    textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",
    fontFamily: FONT,
    borderRadius: "0.25em",
  }

  const boxStyle = {
    display: "flex",
    flexDirection: "row",
    width: "40dvh",
    height: "45dvh",
    zIndex: 0,
    filter: "drop-shadow(0.2svh 0.2svh 0.6svh rgba(0, 0, 0, 0.5))",
    borderRadius: "0.25em",
    alignItems: "center",
    justifyContent: "center",
  };

  const dropStyle = {
    maxWidth: boxStyle.width,
    maxHeight: boxStyle.height,
    backgroundColor: "none",
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    alignContent: "center",
  };

  /* This function is almost the same as the one in level0Maya.jsx */
  function renderImages(droppedItems) {
    let mayaArray = [...droppedItems];
    let containerArray = [];
    if (mayaArray[0] > 0) { // Corn is rendered using a different style than the rest, because corn is rendered next to each other, while the rest is rendered above/below each other.
      containerArray.push(
        <div style={containerStyle}>
          {
            Array.from({length: mayaArray[0]}).map( (index) => { // Use array construct to render corn image exactly mayaArray[0] times.
              return <span key={index} style={{height: itemSize+"dvh"}}><MayaDestination mayaImage={mayaImages[0]} id={[0, 0]} alt="maya-image" isCorn={true} itemSize={itemSize}/></span>
            })
          }
        </div>
      )
    }
    for (let i = 1; i < mayaArray.length; ++i) {
      while (mayaArray[i] > 0) {
        containerArray.push(
          <div style={{...containerStyle, justifyContent: "left"}}>
            <span key={[i, mayaArray[i]]} style={{height: itemSize+"dvh"}}><MayaDestination mayaImage={mayaImages[i]} id={[i, 0]} alt="maya-image" isCorn={false} itemSize={itemSize}/></span>
          </div>
        ) 
        --mayaArray[i];
      }
    }
  
    return (
      <div style={containerArrayStyle}>
        {containerArray}
      </div>
    );
  }
  

  return (
    <div ref={drop} style={dropStyle}>
      <div alt="MayaBox" className="box" style={boxStyle}>
        <React.Fragment key={id}>
          <div>
            {renderImages(droppedItems)}
          </div>
        </React.Fragment>
      </div>
    </div>
  );
}

export default MayaBoxDestination;
